module.exports = __webpack_public_path__ + "static/home-mobile-screen2-ea9068110a71179bd45413601e90aab7.jpeg";